export default __webpack_public_path__ + "static/media/finishSchedule.cf79c0ac.svg";